export {
    IntersectionProvider,
    IntersectionProvider as Provider,
    useIsIntersecting,
} from './IntersectionProvider';
export {
    IntersectionTrigger,
    IntersectionTrigger as Trigger,
} from './IntersectionTrigger';
